export class HTTPError {
  constructor(public status: number, public message: string) {}

  toString() {
    return this.message;
  }
}
